// extracted by mini-css-extract-plugin
module.exports = {"highlight":"_3BVUSKIB","link":"_2RQIXIW4","roleList":"_2Pv9MI69","showAllText":"_1JUFdj8p"};